module.exports = __webpack_public_path__ + "c6b9ed7bc99a7a4c317e05ed301999b7.svg";